import React from "react";

import Button from '@material-ui/core/Button';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';

export const ApproveButton = (props) => {
	return <Button variant="info" style={{ margin: "2vh", minWidth: "10vw" }} startIcon={<ThumbUpAltIcon />} {...props}>Approva</Button>;
}